import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SendMailRequest, SendMailResponse } from '@shared/index';
import { firstValueFrom } from 'rxjs';

/** Versendet E-Mails im Namen des Nutzers über die Backend-API. */
@Injectable({
  providedIn: 'root'
})
export class UserMailService {

  constructor(private http: HttpClient) { }

  /**
   * Sendet eine E-Mail.
   * @param request Empfänger, Betreff und Inhalt der E-Mail.
   * @returns Das Ergebnis des Versands.
   */
  public async sendMail(request: SendMailRequest): Promise<SendMailResponse> {
    return await firstValueFrom(this.http.post<SendMailResponse>('/api/user/mail/send', request));
  }

}
